export const ROLE_ORGANIZATION_ROOT = 'ROLE_ORGANIZATION_ROOT'
export const ROLE_ORGANIZATION_ADMIN = 'ROLE_ORGANIZATION_ADMIN'
export const ROLE_ORGANIZATION_MANAGER = 'ROLE_ORGANIZATION_MANAGER'


export const CLIENT_ROLE_SETT = {
  ROLE_ORGANIZATION_MANAGER,
  ROLE_ORGANIZATION_ADMIN,
  ROLE_ORGANIZATION_ROOT,
}
